import type { Song } from "../types";

/** London Bridge Is Falling Down (traditional, public domain). */
export const londonBridge: Song = {
  id: "london-bridge",
  title: "London Bridge",
  bpm: 105,
  instrument: "piano",
  notes: [
    { key: "G4", beats: 1.5 },
    { key: "A4", beats: 0.5 },
    { key: "G4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "D4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "F4", beats: 2 },
    { key: "E4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "G4", beats: 1.5 },
    { key: "A4", beats: 0.5 },
    { key: "G4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "D4", beats: 2 },
    { key: "G4", beats: 2 },
    { key: "E4", beats: 1 },
    { key: "C4", beats: 3 },
  ],
};
